import { QueryCache, QueryClient } from '@tanstack/react-query';

export const queryCacheConfig = {
  onError: (_error, query) => {
    HandshqApp.GlobalToastRackAPI.addInedibleToast({
      fullMessage: query.meta?.errorMessage,
    });
  },
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 3600000, // 1 hour
    },
  },
  queryCache: new QueryCache(queryCacheConfig),
});

export default queryClient;
